import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FromAbstractToFormControlPipe } from 'lu-from-abstract-to-form-control-pipe';
import { dataService, LuSelectModule, LuSelectModuleConfig, scrollService } from 'lu-select';
import { DataService, ScrollService } from 'lu-services';
import { LuSelectFormlyComponent } from './lu-select-formly.component';

const declarations = [LuSelectFormlyComponent];

const imports = [
	CommonModule,
	ReactiveFormsModule,
	LuSelectModule,
	FromAbstractToFormControlPipe,
	FormlyModule.forChild({
		types: [
			{
				name: 'lu-select',
				component: LuSelectFormlyComponent,
				wrappers: ['form-field']
			}
		]
	})
];

@NgModule({
	imports,
	declarations
})
export class LuSelectFormlyModule {
	static forRoot(config: LuSelectModuleConfig = {}): ModuleWithProviders<LuSelectFormlyModule> {
		return {
			ngModule: LuSelectFormlyModule,
			providers: [
				config.dataService || {
					provide: dataService,
					useClass: DataService
				},
				config.scrollService || {
					provide: scrollService,
					useClass: ScrollService
				}
			]
		};
	}
}
